import { render, staticRenderFns } from "./SettingsNotificationSmtpHost.vue?vue&type=template&id=476a031a&"
import script from "./SettingsNotificationSmtpHost.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmtpHost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports